{
  "hero": {
    "eyebrow": "For producers",
    "title": "Receive upfront cash from your assets and",
    "highlight": "derisk prices and production",
    "subtitle": "DEC Energy integrates into the financial structure of your plant portfolio, without creating conflicts and giving you immediate liquidity."
  },
  "layers": {
    "eyebrow": "Where DEC Energy fits in",
    "title": "A plug-in solution generating immediate cash and derisking",
    "body": "Whatever tariff you selected and however you financed, the DEC Energy solution applies to assets already in operation.",
    "layer1": {
      "label": "Tariff / Route-to-market",
      "chips": [
        "Merchant",
        "PPA",
        "Energy Release",
        "FER X",
        "FER 1",
        "Combinations"
      ]
    },
    "layer2": {
      "label": "Financing structure",
      "chips": [
        "Equity",
        "Project financing",
        "Green bond",
        "Bridge loan",
        "Mezzanine",
        "Refinancing"
      ]
    },
    "dec": {
      "label": "DEC Energy",
      "body": "A contract that applies to assets already in operation. It lets the producer immediately collect the present value of the net flows the asset will generate over the next ten years."
    },
    "nots": [
      {
        "title": "No equity",
        "body": "We do not buy stakes in the asset"
      },
      {
        "title": "No debt",
        "body": "There is no repayment based on an interest rate over time"
      },
      {
        "title": "No changes",
        "body": "Route-to-market and active financing contracts stay unchanged"
      }
    ]
  },
  "serve": {
    "eyebrow": "Who we serve",
    "title": "We elevate your portfolio strategy",
    "sub": "Meeting the needs of small producers, IPPs and utilities",
    "more": "discover more",
    "tiles": [
      {
        "target": "Small producer",
        "promise": "Immediate liquidity without complexity"
      },
      {
        "target": "IPP",
        "promise": "Optimise your equity allocation"
      },
      {
        "target": "Utility",
        "promise": "Accelerate your independent energy transition"
      }
    ]
  },
  "overview": {
    "head": "Immediate cash",
    "sub": [
      "without selling the asset",
      "without debt"
    ],
    "cowLine": "No, it's not a loan",
    "ctaTitle": "Ready to unlock the capital in your plants?"
  },
  "cases": {
    "eyebrow": "Success stories",
    "heading": "For assets of any size, route-to-market and financing structure",
    "sub": "We discount future cash flows based on your goals.",
    "items": {
      "ipp-light": {
        "title": "Regional producer immediately receives €710'000 with DEC Energy",
        "body": "A small producer, 3 months after activating a 5.24 MWp asset backed with €1'181'801 of its own capital, obtains €710'000 to finance the development of new projects.",
        "link": "Go to the small producers section"
      },
      "ipps": {
        "title": "International independent producer optimises its assets with DEC Energy",
        "body": "One of Europe's leading IPPs, signing a 13.67 MWp agreement with DEC Energy, cuts the equity invested in the single asset by 51%, reducing risk and lifting its IRR by 60 basis points",
        "link": "Go to the IPP section"
      },
      "utility": {
        "title": "Utility supports its independent energy transition with DEC Energy",
        "body": "One of the top 15 utilities in Italy, through an agreement on an 18.54 MWp asset, supports the growth of its direct renewable investment assets without further debt.",
        "link": "Go to the Utility section"
      }
    }
  }
}
